import React, { useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import PageShell from '../components/PageShell';
import CustomerNav from '../components/CustomerNav';
import RoomView from '../components/RoomView';

function CustomerRoom() {
    const { id } = useParams();
    const [token] = useState(localStorage.getItem('customerToken'));

    if (!token) {
        return (
            <PageShell title="Inicio de Sesión Requerido" nav={<Button component={RouterLink} to="/auctions" color="inherit">Volver a Subastas</Button>} maxWidth="sm">
                <Alert severity="info">
                    <RouterLink to="/auctions" style={{ color: 'inherit', fontWeight: 700 }}>Inicia sesión o regístrate</RouterLink> para ver esta sala en vivo.
                </Alert>
            </PageShell>
        );
    }

    return (
        <PageShell title="Subasta en Vivo" nav={<CustomerNav />}>
            <RoomView token={token} role="customer" fetchPath={`/customer/rooms/${id}`} />
        </PageShell>
    );
}

export default CustomerRoom;
